@import 'styles/mixins';
@import 'styles/blaze/mixins';

.root {
  --background: var(--blaze-baby-blue);
  --color: #0090db;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 6px;
  border: 4px solid var(--light-100);
  background: var(--background);
  display: flex;
  flex-direction: column;
  min-width: 0;
  &.smaller {
    max-width: 115px;
    height: auto;
  }

  .content {
    position: relative;
    padding: 0 10px 10px 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 12px;
    flex: 1;
    background-origin: content-box;
    color: var(--color);

    .info {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      gap: 12px;
      right: 10px;
      left: 10px;
    }

    .identity {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
      align-self: stretch;
    }

    .details {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
    }

    .logo {
      width: 30px;
      height: 8px;
      position: absolute;
      right: -8px;
      bottom: -8px;
    }

    .name {
      @include xxl-robotobold;
      @include line-clamp(1);
      overflow: hidden;
      color: var(--dark-100);
      text-overflow: ellipsis;
      width: 100%;
      text-align: start;
      -webkit-text-stroke-width: 0.5023290514945984;
      -webkit-text-stroke-color: var(--dark-100);
      font-size: var(--display-name-font-size, 48px);
      font-style: normal;
      line-height: 90%;
      text-transform: uppercase;
    }

    .description {
      @include md-sohne;
      color: var(--color);
    }

    .date {
      @include sm-sohne;
      font-size: 10px;
      font-weight: 700;
      line-height: 100%;
      color: var(--color);
    }
  }

  .imageContainer {
    position: relative;
    flex: 0 1 68%;
    margin: 12px;
    display: flex;
    padding-bottom: 100%;
  }

  .imageBg {
    background-size: cover;
    border-radius: 50%;
    flex: 1;
    aspect-ratio: 1 / 1;
  }

  .avatarContainer {
    position: absolute;
    height: 100%;
    overflow: hidden;
    border-radius: 0 0 50% 50%;
  }

  .image {
    width: 100%;
    position: absolute;
    padding: 0px;
    top: 0;
    right: 0;
  }

  @media (min-width: $phoneMaxWidth) {
    border-width: 8px;

    .content {
      .logo {
        width: unset;
        height: unset;
        position: unset;
        right: unset;
        bottom: unset;
      }
      .name {
        color: var(--color);
        text-align: unset;
        text-shadow: 3.667px 4.715px 0 var(--dark-100);
      }
    }
  }
}
